const TextAreaInput = (props: any) => {
  return (
    <textarea className="devugo-textarea" {...props}>
      ddll
    </textarea>
  );
};

export default TextAreaInput;
